(() => {
  function initialize(scope) {
    scope.querySelectorAll('[data-holistic-review-highlights]:not([data-bound])').forEach(root => {
      root.dataset.bound = 'true';
      const info = root.closest('[id^="ProductInfo-"]');
      const native = info?.querySelector('.jdgm-review-snippet-widget-v2');
      if (!native || native.closest('[data-id]')?.dataset.id !== root.dataset.productId) return;
      const track = root.querySelector('[data-review-track]');
      const position = root.querySelector('[data-review-position]');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const abort = new AbortController();
      let count = 0;
      let current = 0;
      let visible = false;
      let touching = false;
      let hovering = false;
      let drag;
      let focused = false;
      let paused = motion.matches;
      let timer;
      let settling;
      let resize;
      let trackWidth = 0;
      let visibility;
      const clearTimer = () => clearTimeout(timer);
      const cleanup = () => {
        clearTimer();
        clearTimeout(settling);
        resize?.disconnect();
        visibility?.disconnect();
        abort.abort();
      };
      const update = () => {
        const physical = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        current = count > 1 ? ((physical - 1) % count + count) % count : 0;
        const label = `${current + 1} / ${count}`;
        if (position.textContent !== label) position.textContent = label;
        Array.from(track.children).forEach(card => {
          card.setAttribute('aria-hidden', String(card.hasAttribute('data-review-clone') || Number(card.dataset.reviewIndex) !== current));
        });
        // Size the viewport to the active review, rather than the longest neighbour.
        const active = track.children[count > 1 ? current + 1 : 0];
        if (active) {
          const height = `${active.offsetHeight}px`;
          if (track.style.height !== height) track.style.height = height;
        }
        return current;
      };
      const schedule = () => {
        clearTimer();
        if (!root.isConnected) return cleanup();
        const running = count > 1 && visible && !document.hidden && !paused && !touching && !hovering && !focused;
        root.dataset.autoplay = String(running);
        root.toggleAttribute('data-paused', paused);
        position.setAttribute('aria-live', running ? 'off' : 'polite');
        if (running) timer = setTimeout(() => {
          if (!root.isConnected) return cleanup();
          move(1);
        }, 5000);
      };
      const normalize = () => {
        if (count < 2 || touching) return;
        const physical = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (physical === 0 || physical === count + 1) {
          track.scrollTo({left:(physical === 0 ? count : 1) * track.clientWidth, behavior:'instant'});
        }
        update();
      };
      const settle = () => {
        clearTimeout(settling);
        if (touching) return;
        normalize();
        schedule();
      };
      const move = step => {
        clearTimer();
        clearTimeout(settling);
        normalize();
        const physical = current + 1 + step;
        track.scrollTo({left:physical * track.clientWidth, behavior:motion.matches ? 'instant' : 'smooth'});
        update();
        settling = setTimeout(settle, 180);
      };
      const mount = () => {
        const source = Array.from(native.querySelectorAll('.jdgm-rev-snippet-card'));
        if (!source.length) return false;
        const seen = new Set();
        const reviews = source.map(card => ({
          text:card.querySelector('.jdgm-rev-snippet-card__body')?.textContent?.trim() || '',
          author:card.querySelector('.jdgm-rev-snippet-card__reviewer-name')?.textContent?.trim() || '',
          rating:Number(card.querySelector('[data-score]')?.getAttribute('data-score'))
        })).filter(review => {
          const key = `${review.author}\n${review.text}`;
          if (review.rating !== 5 || review.text.replace(/[^\p{L}\p{N}]/gu, '').length < 3 || seen.has(key)) return false;
          seen.add(key);
          return true;
        }).slice(0, 5);
        if (!reviews.length) {
          native.closest('.x-block-app').hidden = true;
          return true;
        }
        reviews.forEach(review => {
          const card = document.createElement('article');
          card.className = 'hc-review-highlights__card';
          const author = document.createElement('span');
          author.className = 'hc-review-highlights__author';
          author.textContent = review.author ? `— ${review.author}` : '';
          const quote = document.createElement('blockquote');
          quote.textContent = review.text;
          const meta = document.createElement('div');
          meta.className = 'hc-review-highlights__meta';
          const rating = document.createElement('span');
          rating.className = 'hc-review-highlights__rating';
          rating.dataset.score = String(review.rating);
          const star = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          star.setAttribute('viewBox', '0 0 24 24');
          star.setAttribute('fill', 'currentColor');
          star.setAttribute('aria-hidden', 'true');
          star.setAttribute('focusable', 'false');
          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', 'm12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2Z');
          star.append(path);
          const label = document.createElement('span');
          label.textContent = `${root.dataset.ratingLabel} ${review.rating}/5`;
          rating.append(star, label);
          meta.append(author, rating);
          card.append(quote, meta);
          track.append(card);
        });
        count = reviews.length;
        Array.from(track.children).forEach((card, index) => { card.dataset.reviewIndex = String(index); });
        if (count > 1) {
          const first = track.firstElementChild.cloneNode(true);
          const last = track.lastElementChild.cloneNode(true);
          [first, last].forEach(card => {
            card.setAttribute('data-review-clone', '');
            card.setAttribute('aria-hidden', 'true');
            card.inert = true;
          });
          track.prepend(last);
          track.append(first);
        }
        track.addEventListener('scroll', () => {
          clearTimer();
          clearTimeout(settling);
          update();
          settling = setTimeout(settle, 180);
        }, {passive:true, signal:abort.signal});
        track.addEventListener('scrollend', settle, {signal:abort.signal});
        root.addEventListener('pointerdown', () => {
          touching = true;
          clearTimer();
        }, {passive:true, signal:abort.signal});
        track.addEventListener('pointerdown', event => {
          if (count < 2 || event.isPrimary === false || event.button !== 0) return;
          normalize();
          drag = {id:event.pointerId, x:event.clientX, y:event.clientY, left:track.scrollLeft, delta:0, horizontal:false};
        }, {passive:true, signal:abort.signal});
        track.addEventListener('pointermove', event => {
          if (!drag || event.pointerId !== drag.id) return;
          const dx = event.clientX - drag.x;
          const dy = event.clientY - drag.y;
          if (!drag.horizontal && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
            drag.horizontal = true;
            track.setAttribute('data-dragging', '');
            track.setPointerCapture(event.pointerId);
          }
          if (!drag.horizontal) return;
          drag.delta = dx;
          event.preventDefault();
          track.scrollLeft = Math.max(0, Math.min((count + 1) * track.clientWidth, drag.left - dx));
        }, {signal:abort.signal});
        const release = event => {
          if (drag && event.pointerId !== drag.id) return;
          touching = false;
          clearTimeout(settling);
          if (drag?.horizontal) {
            const start = Math.round(drag.left / Math.max(1, track.clientWidth));
            const crossed = Math.abs(drag.delta) >= Math.min(50, track.clientWidth * .2);
            const target = Math.max(0, Math.min(count + 1, start + (crossed ? (drag.delta < 0 ? 1 : -1) : 0)));
            track.toggleAttribute('data-dragging', false);
            track.scrollTo({left:target * track.clientWidth, behavior:motion.matches ? 'instant' : 'smooth'});
          }
          drag = undefined;
          settling = setTimeout(settle, 180);
        };
        document.addEventListener('pointerup', release, {passive:true, signal:abort.signal});
        document.addEventListener('pointercancel', release, {passive:true, signal:abort.signal});
        root.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse' || !matchMedia('(hover: hover)').matches) return;
          hovering = true;
          schedule();
        }, {signal:abort.signal});
        root.addEventListener('pointerleave', () => {
          hovering = false;
          schedule();
        }, {signal:abort.signal});
        root.addEventListener('focusin', event => {
          focused = event.target.matches(':focus-visible');
          if (focused) paused = true;
          schedule();
        }, {signal:abort.signal});
        root.addEventListener('focusout', event => {
          if (root.contains(event.relatedTarget)) return;
          focused = false;
          schedule();
        }, {signal:abort.signal});
        track.addEventListener('keydown', event => {
          if (event.target !== track || !['ArrowLeft', 'ArrowRight', ' ', 'Spacebar'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === ' ' || event.key === 'Spacebar') {
            paused = !paused;
            focused = false;
            schedule();
            return;
          }
          paused = true;
          schedule();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }, {signal:abort.signal});
        document.addEventListener('visibilitychange', schedule, {signal:abort.signal});
        motion.addEventListener('change', event => {
          if (event.matches) paused = true;
          schedule();
        }, {signal:abort.signal});
        document.addEventListener('shopify:section:unload', event => {
          if (event.target.contains(root)) cleanup();
        }, {signal:abort.signal});
        resize = new ResizeObserver(() => {
          const width = track.clientWidth;
          // Height changes must not interrupt a swipe or snap to an adjacent review.
          if (width === trackWidth) {
            update();
            return;
          }
          trackWidth = width;
          track.scrollTo({left:(count > 1 ? current + 1 : 0) * width, behavior:'instant'});
          update();
          schedule();
        });
        visibility = new IntersectionObserver(entries => {
          visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .5;
          schedule();
        }, {threshold:[0,.5]});
        native.closest('.x-block-app').hidden = true;
        root.hidden = false;
        track.scrollTo({left:count > 1 ? track.clientWidth : 0, behavior:'instant'});
        update();
        resize.observe(track);
        Array.from(track.children).filter(card => !card.hasAttribute('data-review-clone')).forEach(card => resize.observe(card));
        visibility.observe(root);
        schedule();
        return true;
      };
      if (mount()) return;
      const observer = new MutationObserver(() => {
        if (!root.isConnected || mount()) observer.disconnect();
      });
      observer.observe(native, {childList:true, subtree:true});
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
